import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#0A0A0F] py-12 px-4" data-id="element-227">
      <div className="max-w-2xl mx-auto" data-id="element-228">
        <div className="bg-[#16161F] border border-[#FF6B00] rounded-2xl p-6 sm:p-8 text-center" data-id="element-229">
          <p className="text-[#FF6B00] text-xs font-bold uppercase tracking-widest mb-3" data-id="element-230">
            ⏰ Oferta por tiempo limitado
          </p>

          <h2 className="text-xl sm:text-2xl font-black text-white mb-5" data-id="element-231">
            El precio de lanzamiento termina en:
          </h2>

          <div className="mb-4" data-id="element-232">
            <CountdownTimer size="lg" blinking={true} data-id="element-233" />
          </div>

          <p className="text-white text-sm font-bold mb-6" data-id="element-234">
            Después sube <span className="text-[#FF6B00]" data-id="element-235">USD 5</span> y no
            vuelve a bajar.
          </p>

          {/* Progress bar */}
          <div className="max-w-sm mx-auto" data-id="element-236">
            <div className="w-full bg-[#0A0A0F] rounded-full h-3 overflow-hidden border border-[#FF6B0033] mb-2" data-id="element-237">
              <div className="h-full rounded-full bg-gradient-to-r from-[#FF6B00] to-[#FFD700]" style={{
              width: '68%'
            }} data-id="element-238" />
            </div>
            <div className="flex items-center justify-between" data-id="element-239">
              <span className="text-[#FF6B00] font-bold text-[11px]" data-id="element-240">
                🔴 Cupos limitados
              </span>
              <span className="text-[#B0B0C0] text-[11px]" data-id="element-241">68% tomados</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}